module.exports = __webpack_public_path__ + "img/solution4.aaff28c4.png";